import {AuthService} from '../../services/authService';
import {Router} from 'aurelia-router';
import { SiteParameterAPI } from '../../services/admin/siteParameterAPI';
import {UserMessageService} from '../../services/userMessageService';
import {inject} from 'aurelia-framework';  
import Quill from 'quill';

@inject(AuthService, Router, SiteParameterAPI, UserMessageService)
export class PrivacyPolicy {
   
    constructor(authService, router, api, userMessageService) {
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
        this.saving = false;
    }



    activate(params, route) {
     
        this.status = null;

        this.id = params.id;
        console.log("params in video email", params);
        
        this.load();        
    }

    load() {
        this.api.getPrivacyPolicy(
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }

    attached() {
       
        var Block = Quill.import('blots/block');
        Block.tagName = 'DIV';
        Quill.register(Block, true);
        this.bodyEditor = new Quill('#bodyValue', {
            modules: {
                toolbar: [
                    [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ]
              },
              bounds: '#scrolling-container',
            
              theme: 'snow'  // or 'bubble'
          });

          this.bodyEditor1 = new Quill('#bodyValue1', {
            modules: {
                toolbar: [
                    [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ]
              },
              bounds: '#scrolling-container',
            
              theme: 'snow'  // or 'bubble'
          });   
    }

    
    save() {
        this.saving = true;
        console.log("save data");
        console.log(this.getData());
        if (this.validate()) {
           // this.saving = true;
            this.api.setPrivacyPolicy(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));
        }
    }

    saveLoadSuccess(data) {

        console.log(data);
        this.setData(data);
        
        if (this.saving) {
            this.userMessageService.setUserMessage('user', 'Saved!');
        }
        this.saving = false;
    }

    saveLoadError(msg) {
    
        this.sending = false;
        this.saving = false;
        this.deleting = false;
        this.userMessageService.setUserError("user", msg);

    }
        
    setData(data) {
        this.bodyEditor.container.firstChild.innerHTML = data.PRIVACY_POLICY;
        this.bodyEditor1.container.firstChild.innerHTML = data.TERMS_CONDITIONS;
        
    }
    
    getData() {

        var data = {
            "privacy_policy": this.bodyEditor.container.firstChild.innerHTML,
            "terms_conditions": this.bodyEditor1.container.firstChild.innerHTML
        }
        console.log("Form data: ",data);
        return data;
    }

    validate() {
        var pass = true;      
        return pass;
    }
}
